<template>
  <div>
    <b-container fluid class="px-5">

      <div class="mt-4 d-flex align-items-start justify-content-between">
        <back-arrow :title="food ? food.name : ''"/>
        <show-actions
          @clickOnEditBtn="clickOnEditBtn"
          @clickOnDeleteBtn="clickOnDeleteBtn"
        ></show-actions>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">
        <div class="bold-text main-color">
          Nom
        </div>
        <div v-if="food" class="mt-2">
          {{ food.name }}
        </div>
        <div class="mt-4 bold-text main-color">
          Espèces
        </div>

        <div v-if="families && families.length > 0" v-for="family in families" :key="family.id" class="mt-2">

          <b-link v-b-toggle="'family-collapse-'+family.id" class="m-1" v-if="foodSpeciessForFamily(family.id).length > 0">
            {{ family.name }}
            <span class="when-open"><caret-down-icon size="18px"/></span>
            <span class="when-closed"><caret-up-icon size="18px"/></span>
          </b-link>

          <b-collapse :id="'family-collapse-'+family.id" visible v-if="foodSpeciessForFamily(family.id).length > 0">
            <b-card>
              <ul v-if="foodSpeciessForFamily(family.id) && foodSpeciessForFamily(family.id).length > 0">
                <li v-for="foodSpecies in foodSpeciessForFamily(family.id)" :key="foodSpecies.id">
                  <b-link :to="{ name: 'SpeciesShow', params: { speciesId: foodSpecies.species.id.toString() }}">
                    {{foodSpecies.species.name}}
                  </b-link>
                </li>
              </ul>
              <div v-else>
                N/A
              </div>
            </b-card>
          </b-collapse>
        </div>

      </b-card>

    </b-container>

    <!-- Modal Delete -->
    <food-delete-modal :selectedFood="ui.selectedFood" @didDeleteFood="didDeleteFood()"></food-delete-modal>

  </div>
</template>

<script>

import api from '../../services/api';
import BackArrow from "../../components/BackArrow";
import ShowActions from "../../components/ShowActions";
import FoodDeleteModal from "./FoodDeleteModal";

export default {

  name: 'FoodShow',

  components: {
    BackArrow,
    ShowActions,
    FoodDeleteModal
  },

  data() {
    return {

      foodId: this.$route.params.foodId,
      food: null,
      families: [],
      foodSpeciess: [],

      ui: {
        selectedFood: null
      }

    }
  },

  created () {
    this.fetchData()
  },

  methods: {

    fetchData() {
      this.fetchFood()
      this.fetchFamilies()
      this.fetchFoodSpecies()
    },

    fetchFood() {
      api
        .get(`/food/${this.foodId}`)
        .then(response => {
          this.food = response.data
        })
    },

    fetchFamilies() {
      api
        .get(`/family`)
        .then(response => {
          this.families = response.data
        })
    },

    fetchFoodSpecies() {
      api
        .get(`/foodSpecies?foodId=${this.foodId}`)
        .then(response => {
          this.foodSpeciess = response.data.filter(item => item)
        })
    },

    foodSpeciessForFamily(familyId) {
      if (!this.foodSpeciess || this.foodSpeciess.length === 0) {
        return []
      }
      return this.foodSpeciess.filter(fs => fs.species.family.id === familyId)
    },

    setTotalCount(totalCount) {
      this.totalCount = totalCount
    },

    clickOnEditBtn() {
      this.$router.push({
        name: 'FoodEdit',
        params: {
          foodId: this.food.id
        }
      })
    },

    clickOnDeleteBtn() {
      this.ui.selectedFood = this.food
      this.$bvModal.show('food-delete-modal')
    },

    didDeleteFood() {
      this.ui.selectedCategory = null;
      this.$router.push({
        name: 'FoodIndex'
      }, () => {
        this.$nextTick(() => {
          this.successToast(`Food \"${this.food.name}\" supprimé`)
        })
      })
    },

    successToast(message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    }

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/food/FoodShow.vue